import React, { useState, useEffect, useContext, useMemo } from 'react';
import Navbar from '../components/navbar/Navbar';
import capsuleMini from '../images/header-capsule-text-mini.svg';
import Application from '../components/application/Application';
import Footer from '../components/footer/Footer';
import catalogBgVideo from '../video/cat_video.mp4';
import CatalogProductCard from '../components/CatalogProductCard/CatalogProductCard';
import closeBtn from '../images/Close.svg';
import { fetchCategories, fetchProducts, fetchCategoriesFull } from '../http';
import { useLocation } from 'react-router-dom';

import '../sass/katalog.scss';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import CatalogCarusel from '../components/catalogCarusel';
import { Tab, Tabs } from '@mui/material';
import { HashContext } from '../components/HashProvider';
import { Link } from 'react-router-dom';
import ProductCardItem from '../components/CatalogProductCard/ProductCardItem';
import { useTranslation } from 'react-i18next';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const normalizeApiList = data => {
  if (Array.isArray(data)) return data;
  if (data?.results && Array.isArray(data.results)) return data.results;
  return [];
};

const productBelongsToCategory = (product, categoryId, category) => {
  if (!product?.category?.length || !categoryId) return false;

  const targetId = Number(categoryId);

  return product.category.some(cat => {
    const catId = Number(cat.id);
    if (!Number.isNaN(catId) && catId === targetId) return true;

    if (!category) return false;

    const catKey = (cat.title_key || '').trim().toLowerCase();
    const selKey = (category.title_key || '').trim().toLowerCase();
    if (catKey && selKey && catKey === selKey) return true;

    return cat.title === category.title;
  });
};

const images = [
  {
    label: 'San Francisco – Oakland Bay Bridge, United States',
    imgPath:
      'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Bird',
    imgPath:
      'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Bali, Indonesia',
    imgPath:
      'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
  },
  {
    label: 'Goč, Serbia',
    imgPath:
      'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
  },
];

const Catalog = () => {
  const location = useLocation();
  const ourPartnersPage = location.pathname === '/catalog';
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleStepChange = step => {
    setActiveStep(step);
  };

  const { t, i18n } = useTranslation();

  // =================================================================

  const [categoriesData, setCategoriesData] = useState([]);
  //const [fullCategoriesData, setFullCategoriesData] = useState([]);

  const [value, setValue] = useState(1);

  const [ID, setID] = useState(1);
  const [productsData, setProductsData] = useState([]);
  const [sunflowerOil, setSunflowerOil] = useState([]);
  const [vegetableOil, setVegetableOil] = useState([]);
  const [sunflowerMeal, setSunflowerMeal] = useState([]);
  const { hash } = useContext(HashContext);
  const [cottonOil, setCottonOil] = useState([]);
  const [loading, setLoading] = useState(true);

  const activeCategoryId = value || ID;

  const fetchData = async () => {
    try {
      const [categories, products] = await Promise.all([
        fetchCategories(),
        fetchProducts(),
      ]);

      const categoriesList = normalizeApiList(categories);
      const productsList = normalizeApiList(products);

      setCategoriesData(categoriesList);
      setProductsData(productsList);
      fetchMainTitles(productsList);

      if (categoriesList.length > 0) {
        const hasActive = categoriesList.some(
          c => Number(c.id) === Number(activeCategoryId)
        );
        if (!hasActive) {
          const firstId = categoriesList[0].id;
          setValue(firstId);
          setID(firstId);
        }
      }
    } catch (error) {
      console.error('Error loading catalog:', error);
      setCategoriesData([]);
      setProductsData([]);
    } finally {
      setLoading(false);
      scrollIntoViewById();
    }
  };

  const selectedCategory = useMemo(() => {
    return categoriesData.find(
      item => Number(item.id) === Number(activeCategoryId)
    );
  }, [activeCategoryId, categoriesData]);

  useEffect(() => {
    fetchData();
  }, [i18n.language]);

  // const [categories, setCategories] = useState([]);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch(
  //         "https://api.homescare.uz/ru/products/api/v1/categories/"
  //       );
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       const data = await response.json();
  //       setCategories(data);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const [brands, setBrands] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const lang = i18n.language || localStorage.getItem('language') || 'ru';
        const response = await fetch(
          `https://api.homescare.uz/${lang}/others/api/v1/brands/`
        );
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setBrands(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, [i18n.language]);

  const matchCategoryKey = (product, ...keys) =>
    product.category?.some(category => {
      const key = (category?.title_key || category?.title || '').toUpperCase();
      return keys.some(k => k.toUpperCase() === key);
    });

  const fetchMainTitles = async products => {
    try {
      const vegetableOilCards = products.filter(product =>
        matchCategoryKey(
          product,
          'VEGETABLE OIL',
          'РАСТИТЕЛЬНОЕ МАСЛО',
          "O'SIMLIK MOYI"
        )
      );
      const sunflowerMealCards = products.filter(product =>
        matchCategoryKey(
          product,
          'SUNFLOWER MEAL',
          'ПОДСОЛНЕЧНОЕ МАСЛО',
          'KUNGABOQAR YOGI'
        )
      );
      const cottonOilCards = products.filter(product =>
        matchCategoryKey(product, 'COTTON OIL', 'ХЛОПКОВОЕМАСЛО', 'PAXTA YOGI')
      );
      const sunflowerMealData = products.filter(product =>
        matchCategoryKey(
          product,
          'SUNFLOWER MEAL',
          'ПОДСОЛНЕЧНЫЙШРОТ',
          'KUNGABOQAR YOGI'
        )
      );
      setSunflowerOil(sunflowerMealCards);
      setVegetableOil(vegetableOilCards);
      setCottonOil(cottonOilCards);
      setSunflowerMeal(sunflowerMealData);
    } catch (error) {
      console.error('Error fetching main titles:', error);
    }
  };

  const CustomExpandIcon = () => {
    return <img src={closeBtn} alt="Custom Icon" />;
  };

  const scrollToSection = id => {
    const section = document.getElementById(`targetSectionId${id}`);
    section.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    // Function to extract the number from the fragment
    const extractCategoryFromHash = () => {
      const hash = window.location.hash;
      if (hash.startsWith('#category-')) {
        const categoryNumber = hash.split('-')[1];
        setValue(+categoryNumber);
        setID(+categoryNumber);
      }
    };

    // Extract category on initial render
    extractCategoryFromHash();

    // Optionally, add a hash change listener if the hash might change without a page reload
    window.addEventListener('hashchange', extractCategoryFromHash);

    // Cleanup event listener
    return () =>
      window.removeEventListener('hashchange', extractCategoryFromHash);
  }, [hash]);

  const scrollIntoViewById = () => {
    setTimeout(() => {
      const secEl = document.getElementById('category_box');
      console.log(secEl);

      if (secEl) {
        secEl.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500);
    /* const element = document.getElementById(`category-${id}`);
    if (!element) {
      setTimeout(() => {
        const secEl = document.getElementById(`category-${id}`);
        if (secEl) {
          secEl.scrollIntoView({ behavior: "smooth" });
        }
      }, 1000);
    } else {
      element.scrollIntoView({ behavior: "smooth" });
    } */
  };

  useEffect(() => {
    if (ID) {
      const newHash = window.location.hash;
      if (newHash) {
        setValue(ID);
        scrollIntoViewById();
      }
    }
  }, [ID, hash]);

  if (loading) null;

  const handleChange = (_, newValue) => {
    setValue(newValue);
    setID(newValue);
  };

  // console.log("productsData", productsData);
  //console.log("categoriesData", categoriesData);

  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {
    if (!Array.isArray(productsData) || productsData.length === 0) {
      setFilteredProducts([]);
      return;
    }

    if (!activeCategoryId) {
      setFilteredProducts([]);
      return;
    }

    const filtered = productsData.filter(item =>
      productBelongsToCategory(item, activeCategoryId, selectedCategory)
    );

    setFilteredProducts(filtered);
  }, [productsData, activeCategoryId, selectedCategory]);

  return (
    <>
      <div style={{ overflow: 'hidden' }} className="catalog text-white">
        <div className="video_cat">
          <div className="catalog__main">
            <header className="header">
              <div className="container">
                <Navbar
                  className={ourPartnersPage ? 'hidden-katalog-navbar' : ''}
                />
              </div>
            </header>

            <video 
                autoPlay 
                muted 
                loop 
                playsInline 
                webkit-playsinline 
                x5-playsinline
              >
                <source src={catalogBgVideo} type="video/mp4" />
              </video>

            {/* <h1 style={{marginTop:"6%"}}>NObel trade</h1> */}
            {/* <div className="catalog__main--item">
              <img
                className="pl-2 mb-1"
                src={capsuleMini}
                alt=""
                data-aos="fade-right"
              />
              <p>
               Здоровье человека зависит не только от того, что он ест, но и от того, что его окружает, как и где он живет.
              </p>
            </div> */}
          </div>
        </div>

        <div className="catalog-sections">
          <section className="catalog-info-section">
            <br />
            <br />
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'transparent !important',
                borderRadius: '30px',
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  bgcolor: 'black',
                  flexGrow: 1,
                  maxWidth: { xs: 320, sm: 900 },
                  color: 'white',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  aria-label="visible arrows tabs example"
                  sx={{ color: 'white' }}
                >
                  {categoriesData?.map(({ id, title }) => (
                    <Tab
                      key={id}
                      label={title}
                      value={id}
                      sx={{ color: 'white', fontWeight: 700 }}
                    />
                  ))}
                </Tabs>
              </Box>
            </Box>
            <div id="category_box" className="main-catalog container my-4">
              {selectedCategory && selectedCategory?.title && (
                <h1 className="text-uppercase mb-4">
                  {selectedCategory.title}
                </h1>
              )}
              {selectedCategory && selectedCategory?.description && (
                <p>{selectedCategory.description}</p>
              )}
              <div className="product__list">
                <CatalogProductCard data={filteredProducts} />
              </div>
            </div>

            {
              // categoriesData?.find(({ id }) => id === ID)?.subcategories
              //   ? console.log("categoriesData", categoriesData)
              //   : ""
              // return (
              //   <div
              //     key={index}
              //     className="catalog-info-section-top container"
              //     id={`category-${ID}`}
              //   >
              //     <h2 className="title pt-5 pb-3">
              //       {item?.subcategory}
              //       <img
              //         className="pl-2 mb-1"
              //         src={capsuleMini}
              //         alt=""
              //         data-aos="fade-right"
              //         style={{
              //           marginLeft: "10px",
              //         }}
              //       />
              //     </h2>
              //     <p className="subtitle pb-3" data-aos="zoom-in">
              //       {item?.description}
              //     </p>
              //     <div className="product__list">
              //       <CatalogProductCard
              //         data={
              //           item?.products ||
              //           categoriesData?.find(({ id }) => id === ID)?.products
              //         }
              //       />
              //     </div>
              //     <div className="main-catalog container">
              //       <div className="product__list">
              //         <CatalogProductCard data={item?.products} />
              //       </div>
              //     </div>
              //   </div>
              // );
            }
            <br />
            <br />
            <br></br>
            <br></br>
            <br></br>
            <div className="catalog-brands">
              <h3
                className={`title`}
                style={{ fontSize: '2.1rem', letterSpacing: '-1px' }}
              >
                <span className="about-capsule" data-aos="fade-up">
                  {t('settings.brand')}
                </span>
              </h3>
              <br></br>
              <div className="partenrs">
                <div className="partners-logo d-flex justify-content-between align-items-center flex-wrap"></div>
                <div className="partners--grid2">
                  {brands?.map((i, k) => (
                    <div key={i.id} className="brand-card">
                      <Link to={i?.link}>
                        <img src={i?.image} alt="" />
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="catalog-application pt-3 ">
          <Application />
        </div>

        <Footer />
      </div>
    </>
  );
};
export default Catalog;
